// 自定义消息命令ID定义
export const CMD_ID_DIRECTION: number = 1; // 方向控制命令
export const CMD_ID_STOP = 2; // 停止命令
export const CMD_ID_NECK = 3; // 脖子控制命令
export const CMD_ID_CALL = 4; // 呼叫
export const CMD_ID_MOTION = 5; // 机器人动作(包括手势、身体移动和头部移动)
export const CMD_ID_TRACK = 6;

// 开关 
export const SWITCH_ON = "SWITCH_ON";
export const SWITCH_OFF = "SWITCH_OFF";

// 方向命令 1
export const DIRECTION_UP = "UP";
export const DIRECTION_DOWN = "DOWN";
export const DIRECTION_LEFT = "LEFT";
export const DIRECTION_RIGHT = "RIGHT";
export const DIRECTION_STOP = "STOP";

// 脖子控制命令 3
export const NECK_UP = "NECK_UP";
export const NECK_DOWN = "NECK_DOWN";
export const NECK_LEFT = "NECK_LEFT";
export const NECK_RIGHT = "NECK_RIGHT";
export const NECK_RESET = "NECK_RESET";
export const NECK_YAW_RESET = "NECK_YAW_RESET";
export const NECK_STOP = "NECK_STOP";

// 呼叫指令 4
export const START_VIDEO = "START_VIDEO";
export const STOP_VIDEO = "STOP_VIDEO";
export const HANG_UP = "HANG_UP";

// 机器人手势 5
export const NOD_HEAD = "NOD_HEAD";  // 点头
export const SHAKE_HEAD = "SHAKE_HEAD" //  摇头
export const TURN_HEAD = "TURN_HEAD" // 摇头晃脑
export const OPERA_FACE = "OPERA_FACE" //  变脸
            